const DiamondsSvg = ({ count = 1 }) => {
  // Center: (24,24), radius: 9, diamond size: 12 (vertical/horizontal distance from center to tip)
  const diamond = (cx, cy) => (
    <polygon
      key={`diamond-${cx}-${cy}`}
      points={`${cx},${cy - 6} ${cx + 6},${cy} ${cx},${cy + 6} ${cx - 6},${cy}`}
      fill="url(#diamondGradient)"
    />
  );

  let diamonds = [];
  if (count === 1) {
    diamonds.push(diamond(24, 24)); // Center
  } else if (count === 2) {
    diamonds.push(diamond(15, 24)); // Left
    diamonds.push(diamond(33, 24)); // Right
  } else if (count === 3) {
    diamonds.push(diamond(24, 17)); // Top center
    diamonds.push(diamond(15, 24)); // Left
    diamonds.push(diamond(33, 24)); // Right
  } else {
    // 4 or more
    diamonds.push(diamond(24, 15)); // Top
    diamonds.push(diamond(33, 24)); // Right
    diamonds.push(diamond(15, 24)); // Left
    diamonds.push(diamond(24, 33)); // Bottom
  }

  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {diamonds}
      <defs>
        <linearGradient id="diamondGradient" x1="0" y1="0" x2="0" y2="1" gradientUnits="objectBoundingBox">
          <stop stopColor="#2E90FA" />
          <stop offset="1" stopColor="#53B1FD" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DiamondsSvg;
